import React, { useState } from 'react';
import { 
  Accordion, 
  AccordionSummary, 
  AccordionDetails, 
  Typography, 
  Box, 
  // Chip,
  Grid
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import StarIcon from '@mui/icons-material/Star';
import { AppTheme } from '../../../../theme/App.theme';
import './PanchangAccordion.css';
// import ContentStatusChip from '../../../../components/ContentStatusChip/ContentStatusChip';
import { Icons } from '../../../../config/MuiIcons.config';
import dayjs from 'dayjs';

const PanchangAccordion = ({ 
  title, 
  icon, 
  data = [], 
  type = "tithi", // "tithi", "yoga", "karana", "var"
  className = "",
  style = {}
}) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const getTypeColor = (type) => {
    const colors = {
      tithi: '#17B26A',
      yoga: '#17B26A',
      karana: '#17B26A',
      var: '#17B26A',
      nakshatra: '#17B26A'
    };
    return colors[type] || AppTheme.PRIMARY_COLOR;
  };

  const YellowBackgroundCSS = {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "#FFE4B5", // Light yellow background
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const getTypeIcon = (type) => {
    const icons = {
      tithi: (
        <Box
          sx={YellowBackgroundCSS}
        >
          <Box
            sx={{
              width: '15px',
              height: '15px',
              borderRadius: '50%',
              backgroundColor: AppTheme.PRIMARY_COLOR // Red dot
            }}
          />
        </Box>
      ),
      yoga: (
        <Box
          sx={YellowBackgroundCSS}
        >
          <Icons.GridViewIcon sx={{ color: AppTheme.PRIMARY_COLOR }} />
        </Box>
      ),
      karana: (
        <Box
          sx={{
            ...YellowBackgroundCSS,
            fontSize: '18px',
            fontWeight: 'bold',
            color: AppTheme.PRIMARY_COLOR
          }}
        >
          ॐ
        </Box>
      ),
      var: (
        <Box
          sx={YellowBackgroundCSS}
        >
          <Icons.CalendarIcon sx={{ color: AppTheme.PRIMARY_COLOR }} />
        </Box>
      ),
      nakshatra: (
        <Box
          sx={YellowBackgroundCSS}
        >
          <StarIcon sx={{ color: AppTheme.PRIMARY_COLOR }} />
        </Box>
      )
    }
    
    return icons[type] || (
      <Box
        sx={{
          width: '24px',
          height: '24px',
          borderRadius: '50%',
          backgroundColor: '#FFE4B5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '12px',
          color: '#FF8C00'
        }}
      >
        📋
      </Box>
    );
  };

  const renderTithiCard = (item, index) => (
    <Box
      key={index}
      className="panchang-item-card"
      sx={{
        // border: '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: { xs: '12px', sm: '16px' },
        marginBottom: '12px',
        backgroundColor: '#E2E6FF',
        '&:last-child': { marginBottom: 0 }
      }}
    >
      {/* Tithi Name Chip */}
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
        <Box
          className="tithi-name-chip"
          sx={{
            border: `1px solid #D5D7DA`,
            color: '#414651'
          }}
        >
          <Box
            className="tithi-dot"
            sx={{
              backgroundColor: getTypeColor(type)
            }}
          />
          {item.name}
        </Box>
      </Box>

      <Grid container spacing={2}>
        {(item.startTimeFormatted || item.startTime) && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Start time: {item.startTimeFormatted || item.startTime}
            </Typography>
          </Grid>
        )}
        {(item.endTimeFormatted || item.endTime) && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              End time: {item.endTimeFormatted || item.endTime}
            </Typography>
          </Grid>
        )}
        {item.number && item.number !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Number: {item.number}
            </Typography>
          </Grid>
        )}
        {item.type && item.type !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Type: {item.type}
            </Typography>
          </Grid>
        )}
        {item.paksha && item.paksha !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Paksha: {item.paksha}
            </Typography>
          </Grid>
        )}
        {item.deity && item.deity !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Deity: {item.deity}
            </Typography>
          </Grid>
        )}
        {item.mobility && item.mobility !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Mobility: {item.mobility}
            </Typography>
          </Grid>
        )}
        {item.rulingPlanet && item.rulingPlanet !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Ruling Planet: {item.rulingPlanet}
            </Typography>
          </Grid>
        )}
        {item.devata && item.devata !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Devata: {item.devata}
            </Typography>
          </Grid>
        )}
        {item.nature && item.nature !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Nature: {item.nature}
            </Typography>
          </Grid>
        )}
        {item.lord && item.lord !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Lord: {item.lord}
            </Typography>
          </Grid>
        )}
        {item.element && item.element !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Element: {item.element}
            </Typography>
          </Grid>
        )}
        {item.symbol && item.symbol !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Symbol: {item.symbol}
            </Typography>
          </Grid>
        )}
        {item.syllables && item.syllables !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Syllables: {item.syllables}
            </Typography>
          </Grid>
        )}
        {item.pursuit && item.pursuit !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Pursuit: {item.pursuit}
            </Typography>
          </Grid>
        )}
        {item.gana && item.gana !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Gana: {item.gana}
            </Typography>
          </Grid>
        )}
        {item.direction && item.direction !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Direction: {item.direction}
            </Typography>
          </Grid>
        )}
        {item.guna && item.guna !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Guna: {item.guna}
            </Typography>
          </Grid>
        )}
        {item.bodyPart && item.bodyPart !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Body Part: {item.bodyPart}
            </Typography>
          </Grid>
        )}
        {item.color && item.color !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Color: {item.color}
            </Typography>
          </Grid>
        )}
        {item.nakNumber && item.nakNumber !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Nakshatra Number: {item.nakNumber}
            </Typography>
          </Grid>
        )}
        {item.nakPada && item.nakPada !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Nakshatra Pada: {item.nakPada}
            </Typography>
          </Grid>
        )}
        {item.vriddhi && item.vriddhi !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Vriddhi: {item.vriddhi}
            </Typography>
          </Grid>
        )}
        {item.kshaya && item.kshaya !== "" && (
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={600}>
              Kshaya: {item.kshaya}
            </Typography>
          </Grid>
        )}
      </Grid>

      {/* Special periods */}
      {item.gandanta && (
        <Box sx={{ marginTop: '8px', padding: '8px', backgroundColor: '#ffebee', borderRadius: '4px' }}>
          <Typography variant="body2" color="error" fontWeight={600} sx={{ marginBottom: '4px' }}>
            Gandanta:
          </Typography>
          {Array.isArray(item.gandanta) && item.gandanta.length > 0 ? (
            item.gandanta.map((gandanta, index) => (
              <Typography key={index} variant="body2" color="error" fontWeight={500}>
                {dayjs(gandanta.startTime).format("MMM DD YYYY, hh:mm A")} - {dayjs(gandanta.endTime).format("MMM DD YYYY, hh:mm A")}
              </Typography>
            ))
          ) : (
            item.gandanta && typeof item.gandanta === 'object' && item.gandanta.startTime && item.gandanta.endTime && (
              <Typography variant="body2" color="error" fontWeight={500}>
                {dayjs(item.gandanta.startTime).format("MMM DD YYYY, hh:mm A")} - {dayjs(item.gandanta.endTime).format("MMM DD YYYY, hh:mm A")}
              </Typography>
            )
          )}
        </Box>
      )}

      {item.pakshaRandhra && (
        <Box sx={{ marginTop: '8px', padding: '8px', backgroundColor: '#fff3e0', borderRadius: '4px' }}>
          <Typography variant="body2" color="warning.main" fontWeight={600} sx={{ marginBottom: '4px' }}>
            Paksha Randhra:
          </Typography>
          {Array.isArray(item.pakshaRandhra) && item.pakshaRandhra.length > 0 ? (
            item.pakshaRandhra.map((randhra, index) => (
              <Typography key={index} variant="body2" color="warning.main" fontWeight={500}>
                {dayjs(randhra.startTime).format("MMM DD YYYY, hh:mm A")} - {dayjs(randhra.endTime).format("MMM DD YYYY, hh:mm A")}
              </Typography>
            ))
          ) : (
            item.pakshaRandhra && typeof item.pakshaRandhra === 'object' && item.pakshaRandhra.startTime && item.pakshaRandhra.endTime && (
              <Typography variant="body2" color="warning.main" fontWeight={500}>
                {dayjs(item.pakshaRandhra.startTime).format("MMM DD YYYY, hh:mm A")} - {dayjs(item.pakshaRandhra.endTime).format("MMM DD YYYY, hh:mm A")}
              </Typography>
            )
          )}
        </Box>
      )}

      {item.vishaGhatis && (
        <Box sx={{ marginTop: '8px', padding: '8px', backgroundColor: '#ffebee', borderRadius: '4px' }}>
          <Typography variant="body2" color="error" fontWeight={600} sx={{ marginBottom: '4px' }}>
            Visha Ghatis:
          </Typography>
          {Array.isArray(item.vishaGhatis) && item.vishaGhatis.length > 0 ? (
            item.vishaGhatis.map((ghatis, index) => (
              <Typography key={index} variant="body2" color="error" fontWeight={500}>
                {dayjs(ghatis.startTime).format("MMM DD YYYY, hh:mm A")} - {dayjs(ghatis.endTime).format("MMM DD YYYY, hh:mm A")}
              </Typography>
            ))
          ) : (
            item.vishaGhatis && typeof item.vishaGhatis === 'object' && item.vishaGhatis.startTime && item.vishaGhatis.endTime && (
              <Typography variant="body2" color="error" fontWeight={500}>
                {dayjs(item.vishaGhatis.startTime).format("MMM DD YYYY, hh:mm A")} - {dayjs(item.vishaGhatis.endTime).format("MMM DD YYYY, hh:mm A")}
              </Typography>
            )
          )}
        </Box>
      )}

      {item.bhadra && (
        <Box sx={{ marginTop: '8px', padding: '8px', backgroundColor: '#ffebee', borderRadius: '4px' }}>
          <Typography variant="body2" color="error" fontWeight={600} sx={{ marginBottom: '4px' }}>
            Bhadra:
          </Typography>
          {Array.isArray(item.bhadra) && item.bhadra.length > 0 ? (
            item.bhadra.map((bhadra, index) => (
              <Box key={index} sx={{ marginBottom: '4px' }}>
                {bhadra.bhadraPuccha && (
                  <Typography variant="body2" color="error" fontWeight={500}>
                    Bhadra Puccha: {dayjs(bhadra.bhadraPuccha.start_time).format("hh:mm A")} - {dayjs(bhadra.bhadraPuccha.end_time).format("hh:mm A")}
                  </Typography>
                )}
                {bhadra.bhadraMukha && (
                  <Typography variant="body2" color="error" fontWeight={500}>
                    Bhadra Mukha: {dayjs(bhadra.bhadraMukha.start_time).format("hh:mm A")} - {dayjs(bhadra.bhadraMukha.end_time).format("hh:mm A")}
                  </Typography>
                )}
              </Box>
            ))
          ) : (
            item.bhadra && typeof item.bhadra === 'object' && (
              <Box sx={{ marginBottom: '4px' }}>
                {item.bhadra.bhadraPuccha && (
                  <Typography variant="body2" color="error" fontWeight={500}>
                    Bhadra Puccha: {dayjs(item.bhadra.bhadraPuccha.start_time).format("hh:mm A")} - {dayjs(item.bhadra.bhadraPuccha.end_time).format("hh:mm A")}
                  </Typography>
                )}
                {item.bhadra.bhadraMukha && (
                  <Typography variant="body2" color="error" fontWeight={500}>
                    Bhadra Mukha: {dayjs(item.bhadra.bhadraMukha.start_time).format("hh:mm A")} - {dayjs(item.bhadra.bhadraMukha.end_time).format("hh:mm A")}
                  </Typography>
                )}
              </Box>
            )
          )}
        </Box>
      )}

      {item.bhadraNiwas && (
        <Box sx={{ marginTop: '8px', padding: '8px', backgroundColor: '#fff3e0', borderRadius: '4px' }}>
          <Typography variant="body2" color="warning.main" fontWeight={600} sx={{ marginBottom: '4px' }}>
            Bhadra Niwas:
          </Typography>
          {Array.isArray(item.bhadraNiwas) && item.bhadraNiwas.length > 0 ? (
            item.bhadraNiwas.map((bhadraNiwas, index) => (
              <Box key={index} sx={{ marginBottom: '4px' }}>
                <Typography variant="body2" color="warning.main" fontWeight={500}>
                  {bhadraNiwas.zodiacName} - {bhadraNiwas.bhadraNiwas} ({bhadraNiwas.nature})
                </Typography>
                <Typography variant="body2" color="warning.main" fontWeight={500}>
                  {dayjs(bhadraNiwas.startTime).format("MMM DD YYYY, hh:mm A")} - {dayjs(bhadraNiwas.endTime).format("MMM DD YYYY, hh:mm A")}
                </Typography>
              </Box>
            ))
          ) : (
            item.bhadraNiwas && typeof item.bhadraNiwas === 'object' && item.bhadraNiwas.startTime && item.bhadraNiwas.endTime && (
              <Box sx={{ marginBottom: '4px' }}>
                <Typography variant="body2" color="warning.main" fontWeight={500}>
                  {item.bhadraNiwas.zodiacName || 'N/A'} - {item.bhadraNiwas.bhadraNiwas || 'N/A'} ({item.bhadraNiwas.nature || 'N/A'})
                </Typography>
                <Typography variant="body2" color="warning.main" fontWeight={500}>
                  {dayjs(item.bhadraNiwas.startTime).format("MMM DD YYYY, hh:mm A")} - {dayjs(item.bhadraNiwas.endTime).format("MMM DD YYYY, hh:mm A")}
                </Typography>
              </Box>
            )
          )}
        </Box>
      )}
    </Box>
  );

  return (
    <Accordion
      expanded={expanded === 'panel1'}
      onChange={handleChange('panel1')}
      className={`panchang-accordion ${className}`}
      style={style}
      sx={{
        boxShadow: 'none',
        backgroundColor: '#EFF6FF',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        '&:before': { display: 'none' }
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className='accordion-summary'
        sx={{
          backgroundColor: '#EFF6FF',
          borderRadius: '8px 8px 0 0',
          minHeight: '56px',
          '&.Mui-expanded': {
            minHeight: '56px'
          }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <Box sx={{ marginRight: '12px', fontSize: '20px' }}>
            {getTypeIcon(type)}
          </Box>
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: '16px', sm: '18px' },
              color: AppTheme.PRIMARY_BLACK,
              flex: 1
            }}
          >
            {title}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          padding: "15px 18px",
          backgroundColor: '#EFF6FF'
        }}
      >
        {data.length > 0 ? (
          data.map((item, index) => renderTithiCard(item, index))
        ) : (
          <Typography variant="body2" fontWeight={600} sx={{ textAlign: 'center' }}>
            No {type} data available
          </Typography>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default PanchangAccordion;
